export default "__VITE_ASSET__swVQmmas__"